import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { SimpleDialogComponent } from '../components/simple-dialog/simple-dialog.component';
import { SimpleDialogData } from '../interfaces/simple-dialog-data.interface';

/**
 * Simple dialog service
 */
@Injectable({
  providedIn: 'root',
})
export class SimpleDialogService {
  /**
   * Constructor
   */
  constructor(public dialog: MatDialog) {}

  /**
   * Open modal
   *
   * @param data SimpleDialogData
   */
  open(data: SimpleDialogData): Observable<any> {
    const dialogRef = this.dialog.open(SimpleDialogComponent, { data });

    return dialogRef.afterClosed();
  }
}
